export function getStringHash(str: string): string {
  const withoutWhiteSpace = str.replace(/\s+/g, ' ').trim();
  const hash = Array.from(withoutWhiteSpace).reduce((acc, char) => {
    acc = (acc << 5) - acc + char.charCodeAt(0);
    return acc | 0; // Convert to 32-bit signed integer
  }, 0);

  return hash.toString();
}
